import { FormErrorLabel, FormLabel } from "@/components";
import { Controller } from "react-hook-form";
import { Checkbox } from "../../ui";

const FormCheckbox = ({
  name,
  label,
  control,
  error,
  isRequired,
  onChange,
  ...rest
}: any) => {
  return (
    <div className="flex flex-row items-center gap-1">
      <Controller
        name={name}
        control={control}
        render={({ field }) => (
          <Checkbox
            {...field}
            {...rest}
            checked={field.value}
            onCheckedChange={(val: any) => {
              field.onChange(val);
              onChange && onChange(val);
            }}
          />
        )}
      />
      {label && (
        <FormLabel isCheckbox>
          {label}{" "}
          {rest?.disabled ? (
            <></>
          ) : (
            <span className="text-red-700">{isRequired ? "*" : ""}</span>
          )}
        </FormLabel>
      )}
      {error && <FormErrorLabel>{error}</FormErrorLabel>}
    </div>
  );
};

export default FormCheckbox;
